import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { SensorListFilters } from 'src/components/forms/sensor'
import { SensorFilters } from 'src/enums'
import { CommonSensorList } from '../commonSensorsList'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from '../sensorContextMenu'

interface LostLoRaWanSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const LostLoRaWanSensorList: FC<LostLoRaWanSensorListProps> = ({ data, isLoading, count, states, refetchSensorList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()

  const columns: GridColDef<Sensor>[] = [
    SensorColumnsDataGrid.Id(),
    SensorColumnsDataGrid.Model,
    SensorColumnsDataGrid.DevEUI,
    SensorColumnsDataGrid.LastPing,
    SensorColumnsDataGrid.BatteryLevel,
    SensorColumnsDataGrid.Description,
    SensorColumnsDataGrid.LastContractor,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      <CommonSensorList
        columns={columns}
        count={count}
        data={data}
        isLoading={isLoading}
        filters={<SensorListFilters activeFilters={[SensorFilters.LowBattery, SensorFilters.WeakSignal, SensorFilters.LastPingMoreThanHour]} />}
      />
      <SensorContextMenu
        menuItems={[SensorMenuItemKey.MakeAvailable]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchSensorList={refetchSensorList}
      />
    </>
  )
}
